import { useContext } from 'react';
import { ThemeContext, type Accent, type ResolvedTheme, type Theme } from './ThemeProvider.js';

export interface UseTheme {
  theme: Theme;
  setTheme: (t: Theme) => void;
  resolved: ResolvedTheme;
  accent: Accent;
  setAccent: (a: Accent) => void;
}

/**
 * Preferences hook — mode (light/dark/system) + accent personality theme.
 * Kept on the `useTheme` name so existing call sites keep working; the
 * accent fields are additive.
 */
export function useTheme(): UseTheme {
  return useContext(ThemeContext);
}
